import {Grid, Stack} from "@mui/material";
import React, {FC} from "react";
import {GridItem} from "@/widget/GridItem/GridItem";
import {checkQueryKey, formatTime, getSellerNames} from "@/helper/method";
import {ContractVO, useQueryContract} from "@/service/contract.s";
import {ContractFiles} from "@/widget/CommonDetail/ContractFiles";
import {ContractPO} from "@/model/customer";
import {ServeTable} from "@/widget/CommonDetail/ServeTable";

interface ContractDetailProps {
    full?: boolean; // 1.完整详情 + tab File 2. 半完整详情 + File
    id?: number;
    showProduct?: boolean;
    data?: ContractPO;
}

export const ContractDetail: FC<ContractDetailProps> = ({full, id, data, showProduct}) => {
    const {data: contractData} = useQueryContract({id: id!}, checkQueryKey(id))
    const contract = (data || contractData?.data || {}) as ContractVO

    return <Stack direction={'column'} gap={2}>
        <Grid
            spacing={3}
            container>
            <GridItem title={'合同名称'} content={contract?.contractName}/>
            <GridItem title={'合同编号'} content={contract?.contractNum}/>
            <GridItem title={'成交时间'} content={formatTime("D", contract?.dealTime)}/>
            <GridItem title={'合同金额'} content={contract?.totalPrice}/>
            <GridItem title={'服务数量'} content={contract?.productNum}/>
            <GridItem title={'创建时间'} content={formatTime("D", contract?.createdAt)}/>
            {full && <>
                <GridItem title={'客户名称'} content={contract?.customerName}/>
                <GridItem title={'业务人员'} content={getSellerNames(contract?.creator, contract?.seller)}/>
                <GridItem title={'签约公司'} content={contract?.companyNames}/>
                <GridItem title={'回款计划'} content={contract?.paybackPlans}/>
            </>}
            <GridItem size={12} minHeight={80} title={'备注'} content={contract?.remark}/>
            {showProduct && <ServeTable products={contract?.products}/>}
        </Grid>
        {!full && <ContractFiles contractId={contract.id}/>}
    </Stack>
}